(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

angular.module('classy').component('cpPaypalCommerceWidget', {
  template: '\n    <div class="payment-method-select-btn__paypal-commerce" ng-show="$ctrl.frequency === \'one-time\' && ($ctrl.hasPaypal || $ctrl.hasVenmo)" id="button-container-one-time"></div>\n    <div class="payment-method-select-btn__paypal-commerce" ng-show="$ctrl.frequency !== \'one-time\' && $ctrl.hasPaypal" id="button-container-recurring"></div>\n  ',
  bindings: {
    hasPaypal: '<',
    hasVenmo: '<',
    modelPaypal: '<',
    modelVenmo: '<',
    amount: '<',
    fot: '<',
    frequency: '<',
    onOpen: '&',
    onSuccess: '&',
    onCancel: '&',
    validateForm: '&'
  },
  controller: ["cpConstants", "PayPalSDK", "scBanner", "scOrganizationsService", "scFeeOnTopService", "$timeout", "$q", function controller(cpConstants, PayPalSDK, scBanner, scOrganizationsService, scFeeOnTopService, $timeout, $q) {
    var _this = this;

    var STATUS = cpConstants.STATUS;

    var PAYPAL_FEE_RATE = 0.018;
    var PAYPAL_FEE_FIXED = 0.3;
    var requestCanceller = void 0;

    this.$onInit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.orgName = scOrganizationsService.active.current.name;

              _context.next = 3;
              return PayPalSDK.init().then(function (paypalSDKs) {
                var paypal = paypalSDKs.paypal,
                    paypalRecurring = paypalSDKs.paypalRecurring,
                    merchantId = paypalSDKs.merchantId;

                _this.paypal = paypal;
                _this.paypalRecurring = paypalRecurring;
                _this.merchantId = merchantId;

                _this.FUNDING_SOURCES = [];
                _this.showButtons = {};

                if (_this.hasPaypal) {
                  _this.FUNDING_SOURCES.push(_this.paypal.FUNDING.PAYPAL);
                }

                if (_this.hasVenmo) {
                  _this.FUNDING_SOURCES.push(_this.paypal.FUNDING.VENMO);
                }

                // loop through funding sources once we implement Venmo
                _this.FUNDING_SOURCES.forEach(function (fundingSource) {
                  _this.createButtons(fundingSource);
                });
              });

            case 3:

              _this.addDataIds();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    // One time donations and recurring donations are handled differently,
    // so when the frequency changes from one to the other, we need to clear it
    this.$onChanges = function (_ref2) {
      var frequency = _ref2.frequency,
          amount = _ref2.amount,
          fot = _ref2.fot;

      // cancel previous request if we're sending in a new request
      if (requestCanceller) {
        requestCanceller.resolve(); // cancel previous
      }
      requestCanceller = $q.defer(); // assign new one

      if (amount && _this.isValidAmount(amount.currentValue) || fot && !fot.isFirstChange()) {
        _this.totalAmount = _this.amount;
        scFeeOnTopService.transactionEstimate(_this.amount, {
          processor_name: 'PAYPAL_COMMERCE',
          fot: _this.fot
        }, {
          timeout: requestCanceller.promise
        }, _this.frequency).then(function (_ref3) {
          var data = _ref3.data;
          var charge = data.charge_summary,
              grossAdjustment = data.gross_adjustment;

          if (scFeeOnTopService.donorCoveredFeesEnabled) {
            _this.totalAmount = charge.total_charge;
          }
          var feeSum = parseFloat(grossAdjustment.raw_processor_fee_amount) + parseFloat(grossAdjustment.raw_application_fee_amount);

          var fee = feeSum - _this.totalAmount * PAYPAL_FEE_RATE - PAYPAL_FEE_FIXED;

          // if fee calculation is negative, we should set platform_fees to 0
          // this should never happen, as long as our fees > paypal fees
          // but a negative platformFee prevents the modal from opening.
          _this.platformFee = fee <= 0 ? 0 : fee;
        }).catch(function () {});

        // total amount will be different if campaign is classymode
        if (scFeeOnTopService.fixedFotEnabled) {
          _this.totalAmount = _this.fot ? Number(_this.amount + scFeeOnTopService.calculateFixedFeeOnTop(_this.amount)).toFixed(2) : _this.amount.toFixed(2);
        }
      }

      if (frequency && !frequency.isFirstChange()) {
        if ((_this.isStatusSuccess(_this.modelPaypal) || _this.isStatusSuccess(_this.modelVenmo)) && (frequency.currentValue === 'one-time' || frequency.previousValue === 'one-time')) {
          _this.onCancel();
        }
      }
    };

    this.isStatusSuccess = function (model) {
      if (model && model.status === STATUS.SUCCESS) {
        return true;
      } else {
        return false;
      }
    };

    this.isValidAmount = function (amount) {
      return amount && amount > 0 && amount !== '0' && amount !== '0.00' && amount !== 'clear';
    };

    var createOrder = function createOrder(fundingSource) {
      return function (_data, _actions) {
        var paymentMethod = fundingSource === 'venmo' ? 'Venmo' : 'PayPal_Commerce';
        return PayPalSDK.createOrder(_this.totalAmount, 'USD', paymentMethod);
      };
    };

    // paypal's createBillingAgreement expects us to pass in a billing token
    // the paypal sdk requests it from classypay before it is returned here
    var createBillingAgreement = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.isValidAmount(_this.totalAmount) && _this.validateForm())) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return', PayPalSDK.createBillingAgreementToken());

              case 4:
                return _context2.abrupt('return', onError);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function createBillingAgreement() {
        return _ref4.apply(this, arguments);
      };
    }();

    this.addDataIds = function () {
      var btnContainerOnetime = document.getElementById('button-container-one-time');

      var btnsOneTime = btnContainerOnetime.getElementsByClassName('paypal-buttons');
      if (btnsOneTime.length > 0) {
        btnsOneTime[0].setAttribute('data-id', 'paymethod-' + _this.FUNDING_SOURCES[0]);
      }

      if (btnsOneTime.length > 1) {
        btnsOneTime[1].setAttribute('data-id', 'paymethod-' + _this.FUNDING_SOURCES[1]);
      }

      var btnContainerRecurring = document.getElementById('button-container-recurring');

      var btnsRecurring = btnContainerRecurring.getElementsByClassName('paypal-buttons');
      if (btnsRecurring.length > 0) {
        btnsRecurring[0].setAttribute('data-id', 'paymethod-paypal');
      }
    };

    var onApprove = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data, _actions) {
        var orderID;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                orderID = data.orderID;
                _context3.next = 3;
                return PayPalSDK.getOrderDetails(orderID).then(function (_ref6) {
                  var orderDetails = _ref6.data;

                  var email = _.get(orderDetails, 'payer.email_address');
                  var firstName = _.get(orderDetails, 'payer.name.given_name');
                  var lastName = _.get(orderDetails, 'payer.name.surname');
                  var shippingAddress = _.get(orderDetails, 'purchase_units[0].shipping.address');
                  var details = {
                    email: email,
                    firstName: firstName,
                    lastName: lastName,
                    orderId: orderID,
                    status: STATUS.SUCCESS,
                    shippingAddress: shippingAddress
                  };
                  _this.onSuccess({ params: { details: details, fundingSource: _this.selectedPayment } });
                });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function onApprove(_x, _x2) {
        return _ref5.apply(this, arguments);
      };
    }();

    var onApproveRecurring = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_data, _actions) {
        var agreementId, details;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                agreementId = PayPalSDK.getBillingAgreementToken();
                details = {
                  email: 'PayPal Account',
                  agreementId: agreementId,
                  status: STATUS.SUCCESS
                };
                _context4.prev = 2;
                _context4.next = 5;
                return PayPalSDK.getBillingAgreementTokenDetails(agreementId).then(function (_ref8) {
                  var data = _ref8.data;

                  details.email = _.get(data, 'payer_info.email');
                  details.firstName = _.get(data, 'payer_info.first_name');
                  details.lastName = _.get(data, 'payer_info.last_name');
                  details.shippingAddress = _.get(data, 'shipping_address');
                });

              case 5:
                _context4.next = 9;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](2);

              case 9:

                _this.onSuccess({ params: { details: details } });

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this, [[2, 7]]);
      }));

      return function onApproveRecurring(_x3, _x4) {
        return _ref7.apply(this, arguments);
      };
    }();

    var onError = function onError() {
      $timeout(function () {
        if (!_this.isValidAmount(_this.totalAmount)) {
          scBanner('Please choose an amount before paying with ' + (_this.selectedPayment === 'paypal' ? 'PayPal' : 'Venmo'), 'error');
        }
      });
    };

    var onCancel = function onCancel() {
      _this.onCancel();
    };

    var setSelectedPayment = function setSelectedPayment(fundingSource) {
      _this.selectedPayment = fundingSource;
    };

    var openModal = function openModal(fundingSource) {
      _this.onOpen({ params: { paymentMethod: fundingSource } });
    };

    var isFormValid = function isFormValid() {
      return _this.validateForm();
    };

    // Because the same paypal button cannot be used for both one time and recurring donations
    // We create 2 buttons, and hide the other depending on the selected frequency
    this.createButtons = function (fundingSource) {
      var style = {
        height: 40
      };

      var oneTimeButton = _this.paypal.Buttons({
        fundingSource: fundingSource,
        style: style,
        createOrder: createOrder(fundingSource),
        onApprove: onApprove,
        onClick: function onClick(_data, actions) {
          if (!isFormValid()) {
            actions.reject();
          }
          openModal(fundingSource);
          setSelectedPayment(fundingSource);
        },

        onCancel: onCancel,
        onError: onError
      });

      var recurringButton = _this.paypalRecurring.Buttons({
        fundingSource: fundingSource,
        style: style,
        createBillingAgreement: createBillingAgreement,
        onApprove: onApproveRecurring,
        onClick: function onClick(_data, actions) {
          if (!isFormValid()) {
            actions.reject();
            onError('FORM');
          }
          openModal(fundingSource);
          setSelectedPayment(fundingSource);
        },

        onCancel: onCancel,
        onError: onError
      });

      _this.showButtons[fundingSource] = oneTimeButton.isEligible();

      // we must check that paypal (or venmo) are still valid payment methods since this was
      // kicked off asynchronously. The page will error if we try to render but no div exists.
      if (oneTimeButton.isEligible() && (_this.hasPaypal || _this.hasVenmo)) {
        oneTimeButton.render('#button-container-one-time');
      }

      if (recurringButton.isEligible() && _this.hasPaypal) {
        recurringButton.render('#button-container-recurring');
      }
    };
  }]
});
})();